import React from 'react';
import { getComponentClasses } from '../../utils/app';

interface Props {
    variations?: string[];
}

const Spinner = ({ variations }: Props) => (
    <div className={getComponentClasses('spinner', variations)} />
);

export default Spinner;
